<template>
  <div id='kb-main'>
    <span>第三方应用</span>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex'
// import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'kb-main',
  computed: {
    // ...mapGetters([ '' ]),
  },
  methods: {
  }

}
</script>

<style scoped>
#kb-main {
  padding-left: 10px;
  padding-top: 50px;
  text-align: left;
  height: 100%;
  width: 100%;
}
</style>
